import EPageHeader from '@/components/everridge/EPageHeader';
import { useTranslation } from 'react-i18next';
import { useFaqListApi } from '@/features/faq/hooks/useFaqListApi';
import { useUserRole } from '@/features/identity/hooks/useUserRole';
import FaqOwnerList from '@/features/faq/components/FaqOwnerList';
import FaqAdminList from '@/features/faq/components/FaqAdminList';
import FaqManage from '@/features/faq/components/FaqManage';
import ESearchInput from '@/components/everridge/ESearchInput';
import { useState } from 'react';
import { Roles } from '@/@types/auth.types';
import { Button } from '@/components/ui/button';
import AddIcon from '@/components/icons/AddIcon';
import FaqPageEmpty from '@/features/faq/components/FaqPageEmpty';
import { cn } from '@/lib/utils';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import FaqDetailsMobile from './components/FaqDetailsMobile';

const FaqPage = () => {
	const [faqId, setFaqId] = useState('');
	const [showFaqCreate, setShowFaqCreate] = useState(false);
	const [showFaqDetails, setShowFaqDetails] = useState(false);
	const [searchText, setSearchText] = useState('');

	const { t } = useTranslation();
	const userType = useUserRole();
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

	const { faqListData, isLoadingFaqListData } = useFaqListApi({ searchText });

	const handleCreateNew = () => {
		setFaqId('');
		setShowFaqCreate(true);
	};

	const handleEditSelected = (id: string) => {
		setFaqId(id);
		setShowFaqCreate(true);
	};

	const handleShowDetails = (id: string) => {
		setFaqId(id);
		setShowFaqDetails(true);
	};
	
	return (
		<div className='flex-1 flex flex-col gap-6'>
			<EPageHeader
				title={t('main.faq.title')}
				search={
					userType === Roles.owner && (
						<ESearchInput
							value={searchText}
							setValue={setSearchText}
							containerClassName={cn(!isMobile && 'w-60')}
						/>
					)
				}>
				{userType === Roles.admin && (
					<Button
						size={isMobile ? 'icon' : 'default'}
						onClick={handleCreateNew}>
						<AddIcon className={'stroke-popover-10'} />
						{!isMobile && t('elements.buttons.newFaq')}
					</Button>
				)}
			</EPageHeader>
			<div className='h-full flex flex-col gap-4'>
				{userType === Roles.owner && !!faqListData?.length && (
					<FaqOwnerList
						list={faqListData}
						isMobile={isMobile}
					/>
				)}
				{userType === Roles.admin && !!faqListData?.length && (
					<FaqAdminList
						list={faqListData}
						onClick={handleShowDetails}
						onEdit={handleEditSelected}
						isMobile={isMobile}
					/>
				)}
				{!isLoadingFaqListData && !faqListData?.length && (
					<FaqPageEmpty />
				)}
			</div>
			{showFaqCreate && (
				<FaqManage
					id={faqId}
					onClose={() => setShowFaqCreate(false)}
				/>
			)}
			{showFaqDetails && isMobile && (
				<FaqDetailsMobile
					id={faqId}
					onEdit={handleEditSelected}
					onClose={() => setShowFaqDetails(false)}
				/>
			)}
		</div>
	);
};

export default FaqPage;
